// Zoom/pan guardado por símbolo+TF (fix 2026-10-22). Se guarda RELATIVO a la
// última vela — {v: 2, from, to} con from/to = índice lógico − índice de la
// última vela — y no en índices absolutos: así sobrevive a las velas nuevas,
// a la ventana deslizante del histórico (tope por TF) y a loadMore (que
// antepone velas antiguas y desplaza todos los índices absolutos).
// El formato antiguo ({from, to} absolutos, sin `v`) se ignora: en la
// práctica nunca se restauraba (ver restorePendingRef en ChartRenderer.jsx) y casi siempre era el
// rango por defecto de lightweight-charts guardado por error.
export const SAVED_RANGE_VERSION = 2

export function encodeSavedRange(range, lastIndex) {
  if (!range || !Number.isFinite(lastIndex)) return null
  return { v: SAVED_RANGE_VERSION, from: range.from - lastIndex, to: range.to - lastIndex }
}

// Rango absoluto a aplicar, o null si no se puede restaurar: formato antiguo,
// datos corruptos, o rango que hoy no mostraría ninguna vela (empieza a la
// derecha de la última, o antes de la primera vela cargada).
export function decodeSavedRange(saved, lastIndex) {
  if (!saved || saved.v !== SAVED_RANGE_VERSION) return null
  if (!Number.isFinite(saved.from) || !Number.isFinite(saved.to) || !Number.isFinite(lastIndex)) return null
  const range = { from: lastIndex + saved.from, to: lastIndex + saved.to }
  if (range.to <= range.from || range.from < 0 || range.from > lastIndex) return null
  return range
}

// Índice lógico de la última vela de `series` (búsqueda binaria: barato en
// cada evento de pan/zoom), o null.
export function lastBarLogical(chart, series) {
  try {
    const last = series?.dataByIndex?.(Number.MAX_SAFE_INTEGER, -1)  // MismatchDirection.NearestLeft
    if (last?.time == null) return null
    const ts = chart.timeScale()
    const x = ts.timeToCoordinate(last.time)
    return x == null ? null : ts.coordinateToLogical(x)
  } catch { return null }
}
